import React, { Component } from 'react';
import { ColorPicker, BasePopoverPanel } from 'crazyEditor/components/EditorUI/BaseUI/index';
import _ from 'lodash';
import { connect } from 'react-redux';
import { closeLazyPanel } from 'crazyEditor/redux/modules/panel/panel';
import PropTypes from 'prop-types';
import Radium from 'radium';
import MenuItem from 'material-ui/MenuItem';
import { setElementUpdatePreview, clearElementUpdatePreview } from 'crazyEditor/redux/modules/element/actions/previewElementActions';
import { updateDesktopElement } from 'crazyEditor/redux/modules/element/actions/desktopElementActions';
import {getBackgroundTextureSetter, getBackgroundGradientSetter, getBackgroundGradient, getBackgroundTexture} from 'crazyEditor/core/elements/utils/commonElementMethods';
import { BACKGROUND_IMAGE_TYPE } from 'crazyEditor/core/constants/panelConstants';
import * as Colors from 'material-ui/styles/colors';
import SimpleSelectableBox from 'crazyEditor/components/EditorUI/BaseUI/SelectableBoxes/SimpleSelectableBox';


const TEXTURE_THUMBNAIL_SIZE = 78;

const styles = {
  container: {
    maxHeight: 400,
    width: 284,
    display: 'flex',
    flexWrap: 'wrap',
    justifyContent: 'space-between',
  }
};

const textures = [
  `url(https://crazylister.com${require('./textures/t1.png')})`,
  `url(https://crazylister.com${require('./textures/t2.png')})`,
  `url(https://crazylister.com${require('./textures/t3.png')})`,
  `url(https://crazylister.com${require('./textures/t4.png')})`,
  `url(https://crazylister.com${require('./textures/t5.png')})`,
  `url(https://crazylister.com${require('./textures/t6.png')})`,
  `url(https://crazylister.com${require('./textures/t7.png')})`,
  `url(https://crazylister.com${require('./textures/t8.png')})`,
];

const gradients = [
  'linear-gradient(to top, rgba(0, 0, 0, 0) 0%, rgba(0, 0, 0, 0.4) 100%)',
  'linear-gradient(to top, rgba(0, 0, 0, 0) 0%, rgba(0, 0, 0, 0.6) 100%)',
  'linear-gradient(to top, rgba(0, 0, 0, 0) 0%, rgba(0, 0, 0, 0.8) 100%)',
  'linear-gradient(to top, rgba(0, 0, 0, 0) 35%, rgba(0, 0, 0, 0.4) 100%)',
  'linear-gradient(to top, rgba(0, 0, 0, 0) 35%, rgba(0, 0, 0, 0.6) 100%)',
  'linear-gradient(to top, rgba(0, 0, 0, 0) 35%, rgba(0, 0, 0, 0.8) 100%)',
  'linear-gradient(to top, rgba(255, 255, 255, 0) 0%, rgba(255, 255, 255, 0.4) 100%)',
  'linear-gradient(to top, rgba(255, 255, 255, 0) 0%, rgba(255, 255, 255, 0.6) 100%)',
  'linear-gradient(to top, rgba(255, 255, 255, 0) 0%, rgba(255, 255, 255, 0.8) 100%)',
  'linear-gradient(to top, rgba(255, 255, 255, 0) 35%, rgba(255, 255, 255, 0.4) 100%)',
  'linear-gradient(to top, rgba(255, 255, 255, 0) 35%, rgba(255, 255, 255, 0.6) 100%)',
  'linear-gradient(to top, rgba(255, 255, 255, 0) 35%, rgba(255, 255, 255, 0.8) 100%)',
  'linear-gradient(to top, rgb(59, 103, 158) 0%, rgb(43, 136, 217) 50%, rgb(32, 124, 201) 51%, rgb(125, 185, 232) 100%)',
  'linear-gradient(to top, rgb(76, 76, 76) 0%, rgb(89, 89, 89) 12%, rgb(102, 102, 102) 25%, rgb(71, 71, 71) 39%)',
  'linear-gradient(to top, rgb(135, 224, 253) 0%, rgb(83, 203, 241) 40%, rgb(83, 203, 241) 40%, rgb(5, 171, 224) 100%)',
  'linear-gradient(to top, rgb(240, 249, 255) 0%, rgb(203, 235, 255) 47%, rgb(161, 219, 255) 100%)',
  'linear-gradient(to top, rgb(0, 183, 234) 0%, rgb(0, 158, 195) 100%)',
  'linear-gradient(to top, rgb(167, 199, 220) 0%, rgb(133, 178, 211) 100%)',
  'linear-gradient(to top, rgb(208, 228, 247) 0%, rgb(115, 177, 231) 24%, rgb(10, 119, 213) 50%, rgb(83, 159, 225) 79%, rgb(135, 188, 234) 100%)',
  'linear-gradient(to top, rgb(63, 76, 107) 0%, rgb(63, 76, 107) 100%)',
  'linear-gradient(to top, rgb(254, 252, 234) 0%, rgb(241, 218, 54) 100%)',
  'linear-gradient(to top, rgb(169, 3, 41) 0%, rgb(143, 2, 34) 44%, rgb(109, 0, 25) 100%)',
  'linear-gradient(to top, rgb(169, 219, 128) 0%, rgb(150, 197, 111) 100%)',
  'linear-gradient(to top, rgb(201, 222, 150) 0%, rgb(138, 182, 107) 44%, rgb(57, 130, 53) 100%)',
  'linear-gradient(to top, rgb(191, 210, 85) 0%, rgb(142, 185, 42) 50%, rgb(114, 170, 0) 51%, rgb(158, 203, 45) 100%)',
  'linear-gradient(to top, rgb(69, 72, 77) 0%, rgb(0, 0, 0) 100%)',
  'linear-gradient(to top, rgb(255, 48, 25) 0%, rgb(207, 4, 4) 100%)',
  'linear-gradient(to top, rgb(234, 185, 45) 0%, rgb(199, 152, 16) 100%)',
  'linear-gradient(to top, rgb(254, 255, 232) 0%, rgb(214, 219, 191) 100%)',
  'linear-gradient(to top, rgb(203, 96, 179) 0%, rgb(173, 18, 131) 50%, rgb(222, 71, 172) 100%)'
];

function isNone(style) {
  return _.isNil(style) || style.toLowerCase() === 'none';
}

function isBackgroundStyleEqual(style1, style2) {
  return isNone(style1) && isNone(style2) ||
    (!isNone(style1) && !isNone(style2) && style1.toLowerCase() === style2.toLowerCase());
}

@connect(
  false,
  {closeLazyPanel, setElementUpdatePreview, clearElementUpdatePreview, updateDesktopElement}
)
@Radium
export default class TextureOrGradientPanel extends Component {

  constructor(props) {
    super();
    this.initWithProps(props);
  }

  componentWillReceiveProps(nextProps) {
    this.initWithProps(nextProps);
  }

  onChange = (value) => {
    const { panelProps, setElementUpdatePreview, open } = this.props;
    const { selectedElementIds, selectedElements } = panelProps;

    if (!open) {
      return;
    }

    setElementUpdatePreview(selectedElementIds, this.getSetter(selectedElements[0], value));
  };

  onCancel = () => {
    const { closeLazyPanel, panelName, clearElementUpdatePreview} = this.props;

    clearElementUpdatePreview();
    closeLazyPanel(panelName);
  };

  onSelect = (value) => {
    const { closeLazyPanel, updateDesktopElement, panelProps} = this.props;
    const { selectedElementIds, selectedElements } = panelProps;

    updateDesktopElement(selectedElementIds, this.getSetter(selectedElements[0], value));
    closeLazyPanel(this.props.panelName);
  };

  initWithProps(props) {
    if (props.panelProps.type === BACKGROUND_IMAGE_TYPE.GRADIENT) {
      this.getSetter = getBackgroundGradientSetter;
      this.values = gradients;
      this.valueGetter = getBackgroundGradient;
      this.name = 'Gradient';
    } else {
      this.getSetter = getBackgroundTextureSetter;
      this.values = textures;
      this.valueGetter = getBackgroundTexture;
      this.name = 'Texture';
    }
  }

  render() {
    const { panelName, anchorEl, open, panelProps } = this.props;
    const {name} = this;
    const element = panelProps.selectedElements[0];
    const selectedValue = this.valueGetter(element);
    return (
      <BasePopoverPanel
        panelName={panelName}
        anchorEl={anchorEl}
        open={open}
        onRequestClose={this.onCancel}
        style={{width: 320, padding: 20, maxHeight: 400, overflowX: 'hidden', overflowY: this.values.length === 8 ? 'hidden' : 'auto', height: this.values.length === 8 ? 320 : null}}
      >
        <div
          style={styles.container}
          onMouseLeave={this.props.clearElementUpdatePreview}
        >
          {
            [
              <SimpleSelectableBox selected={isNone(selectedValue)}
                                   key="SimpleSelectableBox-noGradient"
                                   style={{marginBottom: 12}}>
                <MenuItem
                  innerDivStyle={{height: TEXTURE_THUMBNAIL_SIZE, fontSize: 16, textAlign: 'center', lineHeight: '24px', display: 'flex', flexDirection: 'column', justifyContent: 'center', padding: 0}}
                  primaryText={[<div>No</div>, <div>{name}</div>]} onMouseEnter={this.onChange.bind(this, null)}
                  onClick={this.onSelect.bind(this, null)} key="MenuItem-noBorder"
                  style={{borderWidth: 6, borderColor: Colors.grey700, width: TEXTURE_THUMBNAIL_SIZE, height: TEXTURE_THUMBNAIL_SIZE, backgroundColor: Colors.grey200}}
                />
              </SimpleSelectableBox>,
              _.map(this.values, (value, index) => {
                return (
                  <SimpleSelectableBox selected={isBackgroundStyleEqual(value, selectedValue)}
                                       key={`SimpleSelectableBox-${index}`}
                                       style={{marginBottom: 12}}>
                    <MenuItem
                      onMouseEnter={this.onChange.bind(this, value)}
                      onClick={this.onSelect.bind(this, value)}
                      key={value}
                      style={{borderWidth: 6, borderColor: Colors.grey700, backgroundImage: value, width: TEXTURE_THUMBNAIL_SIZE, height: TEXTURE_THUMBNAIL_SIZE, backgroundColor: Colors.grey200}}/>
                  </SimpleSelectableBox>
                );
              })
            ]
          }
        </div>
      </BasePopoverPanel>
    );
  }
}

TextureOrGradientPanel.propTypes = {
  panelName: PropTypes.string.isRequired,
  anchorEl: PropTypes.object.isRequired,
  open: PropTypes.bool.isRequired,
  panelProps: PropTypes.shape({
    selectedElementIds: PropTypes.array.isRequired,
    selectedElements: PropTypes.array.isRequired,
    type: PropTypes.oneOf(_.values(BACKGROUND_IMAGE_TYPE)).isRequired
  })
};